import { useTranslation } from "@msuite/ui/localization";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface ContactProjectsIndicatorProps {
	projects: Array<Pick<Tables<"projects">, "id" | "name">>;
}

export function ContactProjectsIndicator({ projects }: ContactProjectsIndicatorProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<p>
			{projects.length} {t("projects.projects")}
		</p>
	);
}
